// @mui
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material'
// @mui/icons-material
import LayoutModeIcon from '@mui/icons-material/ViewDay'
//
import i18n from 'i18next'
import PropTypes from 'prop-types'
import * as React from 'react'
//
import { MODES, MODE_ONE_BY_ONE, MODE_SEQUENTIAL, MODE_TWO_IN_ONE } from '../Viewer'
//

const LayoutModeButton = (props) => {
  const { onChange, mode, buttonProps, iconProps } = props
  // states
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null)
  const menuOpen = Boolean(menuAnchorEl)
  //

  //
  // functions
  //
  const handleLayoutModeChange = (newMode) => {
    onChange && onChange(newMode)
    setMenuAnchorEl(null)
  }
  const handleOpenModeMenu = (event) => {
    setMenuAnchorEl(event.currentTarget)
  }
  const handleLayoutMenuOnClose = () => {
    setMenuAnchorEl(null)
  }

  return (
    <>
      <Tooltip arrow title="表示方法を変更">
        <IconButton
          color="inherit"
          onClick={handleOpenModeMenu}
          {...buttonProps}
        >
          <LayoutModeIcon {...iconProps} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={handleLayoutMenuOnClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {MODES.map((opt, i) => {
          var label = null
          switch (opt) {
            case MODE_ONE_BY_ONE:
              label = i18n.t('page_mode_one_by_one')
              break
            case MODE_TWO_IN_ONE:
              label = i18n.t('page_mode_two_in_one')
              break
            case MODE_SEQUENTIAL:
              label = i18n.t('page_mode_sequential')
              break
            default:
              label = `${Math.round(opt * 100)}%`
          }
          return (
            <MenuItem
              key={i}
              value={opt}
              onClick={() => handleLayoutModeChange(opt)}
              selected={mode === opt}
            >{label}</MenuItem>
          )
        })}
      </Menu>
    </>
  )
}
LayoutModeButton.propTypes = {
  mode: PropTypes.number,
  onChange: PropTypes.func,
  buttonProps: PropTypes.object,
  iconProps: PropTypes.object,
}
LayoutModeButton.defaultProps = {
  mode: -1,
  onChange: null,
  buttonProps: {},
  iconProps: {},
}

export default LayoutModeButton
